import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from '@/views/shared/routes.js';
import VueBodyClass from 'vue-body-class';



Vue.use(VueRouter);

let router = new VueRouter({
    routes,
    mode: "history",

});

const vueBodyClass = new VueBodyClass(routes);

// Router auth middleware

router.beforeResolve((to, from, next) => {
    vueBodyClass.guard(to, next)
    if (to.meta.middleware || to.meta.controller || to.path) {
        if (!localStorage.getItem('token') && to.meta.middleware.includes('auth')) {
            axios.get('api/saml-setting-info').then(function (response) {
                let res = response.data;
                if (res.status == 1 || res.status == '1') {
                    window.location.href = "/saml/" + res.uuid + "/login";
                } else {
                    next('/auth/login');
                }
            })
        } else if (localStorage.getItem('token') && to.meta.middleware.includes('guest')) {
            //    next('/modules/home');
        } else if (!window.app.register && to.meta.middleware.includes('register')) {
            //    next('/auth/login');
        } else if (localStorage.getItem('token') && to.meta.middleware.includes('auth')) {
            localStorage.removeItem('Errors');
            axios.post('api/auth/check', { controller: to.meta.controller, path: to.path, meta: to.meta }).then(function (response) {
                localStorage.setItem('current_date', response.data.current_date);
                response.data.permission ? next() : next('/modules/notaccess');
            });
        } else {
            // next();
        }
    } else {
        //  next();
    }
});

export default router;
